import { call, put, takeEvery } from "redux-saga/effects";
import { getAllTaxes } from "../../api/pricing";
import { PricingActions } from "../../store/pricing/actions";
import { TAXES_REQUEST } from "../../constants/pricing";

function* TaxesRequestSaga(): any {
  try {
    const taxes = yield call(getAllTaxes);
    yield put(PricingActions.taxesSuccessAction(taxes));
  } catch (e: any) {
    yield put(PricingActions.taxesFailureAction(e));
  }
}

export function* taxesInfoSaga() {
  yield takeEvery(TAXES_REQUEST, TaxesRequestSaga);
}
